// Node modules
import { nanoid } from 'nanoid';

//components
import Button from '@/components/global-components/Button';

//themes
import theme from '@/themes/index';

const Item = ({
  content: {
    title,
    buttons, 
  },
  isDesktop,
  containerStyles,
  contentStyles,
}) => (
  <>
    <div className='container' style={containerStyles}>
      <div className='content' style={contentStyles}>
        { title && <p className='body-text-large cpi-monserrat-bold'>{title}</p> }
        {buttons.map(({
          primaryButton,
        }) => (
          <Button
            key={nanoid()}
            className={primaryButton.style.toLowerCase()}
            text={primaryButton.title}
            href={primaryButton.url}
            target={primaryButton.openInAnotherPage ? '_blank' : '_self'}
            styles={{
              width: isDesktop ? 'fit-content' : '100%',
              padding: '0 1rem',
            }}
          />
        ))}
      </div>
    </div>
    <style jsx>{`
      div.container {
        backdrop-filter: blur(0.625rem);
        opacity: 1;
        border-radius: 1.5rem;
        background-color: rgba(255, 255, 255, 0.5);
        justify-content: center;
        display: flex;
        flex-direction: row;
        min-height: 7.5rem;
      }

      div.container .content {
        padding: 1rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
      }

      div.container .content h6 {
        font-family: ${theme.fontFamilies.montserratBold};
        padding-bottom: 1rem;
        margin-block-start: 0;
        margin-block-end: 0;
        margin-inline-start: 0;
        margin-inline-end: 0;
      }

      @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
        div.container {
          width: 26.25rem;
          min-height: 10rem;
        }
      }
    `}</style>
    <style global jsx>{`
      div.container .content .btn.item-button {
        margin: 0 !important;
      }
    `}</style>
  </>
);

export default Item;
